module.exports = __webpack_public_path__ + "img/flyer_reclamo2020.4c3e4300.jpg";